
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class ServiceSection extends Vue {
  @Prop({ type: String, default: null }) readonly title: string;

  get showHeadline() {
    return this.title || this.hasHeadlineContent;
  }

  get hasHeadlineContent(): boolean {
    return !!this.$slots["headline"];
  }

  get hasContent(): boolean {
    return !!this.$slots["default"];
  }
}
